import React, { useState,useEffect } from "react";
import "./Card.css";
import { RangeCalendar, SingleCalendar,TravelerSelector,RoomSelector } from "../../../../components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { axiosPost,axiosGet } from "../../../../utils/apis/api";
import { motion, AnimatePresence } from "framer-motion";
import bedIcon from "../../../../assets/images/packages/svg/fluent_bed-24-regular.svg"; 
import { useTranslation } from "../../../../contexts/TranslationContext";
import dayjs from "dayjs";

const Card = ({ url, packageId, packageData }) => {
  const [showModal, setShowModal] = useState(false);

  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [childrenAges, setChildrenAges] = useState([]);
  const [infants, setInfants] = useState(0);
  const [email, setEmail] = useState(null);
  const [full_name, setFullName] = useState(null);
  const [mobile_number, setMobileNumber] = useState(null);
  // const [selectedRange, setSelectedRange] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [flexibleTravelDates, setFlexibleTravelDates] = useState(false);
  const [request_loading, setRequestLoading] = useState(false);
  const [requestSuccess, setRequestSuccess] = useState(false);
  const { t } = useTranslation();
  const [single, setSingle] = useState(0);
  const [double, setDouble] = useState(0);
  const [triple, setTriple] = useState(0);
  const [price, setPrice] = useState(0);

  const totalTravelers = adults + childrenAges.filter(age => age >= 9).length;

useEffect(() => {
  if (single + double + triple > totalTravelers) {
    setSingle(0);
    setDouble(0);
    setTriple(0);
  }
}, [totalTravelers]);
  console.log("packageData",packageData);
  const whatsAppMessage = `
  Hello! I'm interested in this travel package.
  
  Travelers:
  - Adults: ${adults}
  - Package Name: ${packageData.name1} 
  - Package Destination: ${packageData.destination_name}
  - Children: ${children}${
    children > 0 &&
    childrenAges.length > 0 &&
    childrenAges.some((age) => !age && age !== 0)
      ? ` (${childrenAges.join(", ")} years)`
      : ""
  }
${
  startDate && endDate
    ? `\nTravel Dates: ${dayjs(startDate).format("MM/DD/YYYY HH:mm")} to ${dayjs(endDate).format("MM/DD/YYYY HH:mm")}`
    : ""
}
    
  Please contact me for more details.
  `;

  const [errors, setErrors] = useState({});
  // const handleDateChange = ({ startDate, endDate }) => {
  //   setSelectedRange({ startDate, endDate });
  // };
const handleDateChange = (e) => {
  const selected = e.value;
  setStartDate(selected);

  let numberOfDays = 0;
  if (packageData?.duration) {
    numberOfDays = Math.round(packageData.duration / (60 * 60 * 24));
  } else if (packageData?.activities && Object.keys(packageData.activities).length > 0) {
    numberOfDays = Object.keys(packageData.activities).length;
  }

  if (selected && numberOfDays > 0) {
    const calculatedEnd = new Date(selected);
calculatedEnd.setDate(calculatedEnd.getDate() + numberOfDays);
    setEndDate(calculatedEnd);
  } else {
    setEndDate(null);
  }
};




  const calculatePrice = () => {
    if (!packageData) return 0;

    if (packageData.pricing_type === "Total Pricing") {
      return packageData.price;
    }

    // Sum includes prices
    const includesSum = (packageData.includes || []).reduce((sum, item) => {
      return sum + parseFloat(item.price || 0);
    }, 0);

    // Sum activities prices
    const activitiesSum = Object.values(packageData.activites || {}).reduce(
      (sum, dayActivities) => {
        const daySum = dayActivities.reduce((daySum, activity) => {
          return daySum + parseFloat(activity.price || 0);
        }, 0);
        return sum + daySum;
      },
      0
    );

    return includesSum + activitiesSum;
  };


const fetchPrice = async ({ single, double, triple }) => {
    const newErrors = {};

  // Validate Rooms Capacity
  const totalRoomsCapacity = single * 1 + double * 2 + triple * 3;
  const totalTravelers = adults + childrenAges.filter(age => age >= 9).length;

  if (totalRoomsCapacity === 0 && totalTravelers > 0) {
    newErrors.rooms = t("RoomsRequired"); 
  } else if (totalRoomsCapacity < totalTravelers) {
    newErrors.rooms = t("NotEnoughRooms"); 
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors); 
    return; 
  }

  setErrors({});

  try {
    const roomsArray = [];
    for (let i = 0; i < single; i++) roomsArray.push(1);
    for (let i = 0; i < double; i++) roomsArray.push(2);
    for (let i = 0; i < triple; i++) roomsArray.push(3);
    

    const params = {
      package_id: packageId,
      rooms: JSON.stringify(roomsArray),
      travelers: JSON.stringify({
        adults,
        children,
        children_ages: childrenAges,
      }),
    };

    const response = await axiosGet(
      `${url}/api/method/alltimes.alltimes_travel.doctype.all_time_package.all_time_package.get_package_price`,
      params
    );

    if (response?.result?.price) {
      setPrice(response.result.price);
    }
  } catch (error) {
    console.error("Error fetching price:", error);
  }
};


  const handleRoomsChange = ({ single, double, triple }) => {
    setSingle(single);
    setDouble(double);
    setTriple(triple);
    fetchPrice({ single, double, triple });
    };

  const handleRequest = async () => {
    const newErrors = {};

    // Validate Full Name
    if (!full_name || full_name.trim() === "") {
      newErrors.full_name = t("FullNameRequired");
    }

    // Validate Email
    if (!email || email.trim() === "") {
      newErrors.email = t("EmailRequired");
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        newErrors.email = t("EmailValidation");
      }
    }

    // Validate Mobile Number (simple digit check and length)
    const mobileRegex = /^[0-9]{8,15}$/;
    if (!mobile_number || mobile_number.trim() === "") {
      newErrors.mobile_number = t("MobileNumberRequired");
    } else if (!mobileRegex.test(mobile_number)) {
      newErrors.mobile_number = t("MobileNumberValidation");
    }

    // Validate Date Range
    // if (!selectedRange?.startDate || !selectedRange?.endDate) {
    //   newErrors.selectedRange = t("TravelDateValidation");
    // }
    if (!startDate || !endDate) {
      newErrors.startDate = t("TravelDateValidation");
    }

    if (
      !childrenAges ||
      childrenAges.length !== children ||
      childrenAges.some((age) => !age && age !== 0)
    ) {
      newErrors.childrenAges = t("ChildrenAgesValidation");
    }

    // Validate Rooms Capacity
const totalRoomsCapacity = single * 1 + double * 2 + triple * 3;
const totalTravelers = adults + childrenAges.filter(age => age >= 9).length;

if (totalRoomsCapacity === 0 && totalTravelers > 0) {
  newErrors.rooms = t("RoomsRequired");
} else if (totalRoomsCapacity < totalTravelers) {
  newErrors.rooms = t("NotEnoughRooms");
}

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // No errors: proceed with submission
    setErrors({});

    const roomsArray = [];
    for (let i = 0; i < single; i++) roomsArray.push(1);
    for (let i = 0; i < double; i++) roomsArray.push(2);
    for (let i = 0; i < triple; i++) roomsArray.push(3); 

    const payload = {
      email: email,
      full_name: full_name,
      mobile_number: mobile_number,
      adult_num: adults,
      infant_num:infants,
      // "form_date": selectedRange[0],
      // "to_date": selectedRange[1],
      from_date: dayjs(startDate).format("YYYY-MM-DD HH:mm:ss"),
      to_date: dayjs(endDate).format("YYYY-MM-DD HH:mm:ss"),
      all_time_package: packageId,
      rooms: roomsArray,
      flexible_travel_dates_1: flexibleTravelDates,

      // "children_num": children,

      // "ages": childrenAges
    };

    if (children >= 0) {
      payload.children_num = children;
      payload.ages = childrenAges;
    }

    try {
      const response = await axiosPost(
        `${url}/api/method/alltimes.alltimes_travel.doctype.quote.quote.quote`,
        // JSON.stringify(payload)
        payload 
      );

      if (response.status !== 200) throw new Error("failed");
      // const packageData = await packageResponse.json();
      toast.success("Request Added!", {
        position: "bottom-right",
      });
      setRequestLoading(false);
      setRequestSuccess(true);
    } catch (error) {
      toast.error(t("ErrorOccurredWhileAddingPackage"), {
        position: "bottom-right",
      });
      setRequestLoading(false);
      console.error("Error:", error);
    }
  };

  useEffect(() => {
  if (packageData?.price) {
    setPrice(packageData.price);
  }
}, [packageData]);

  return (
    <>
      <AnimatePresence mode="wait">
        {!requestSuccess ? (
          <motion.div
            key="form"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
            className="details-card-package"
          >
            <div className="details-card-package">
              <div className="details-card-package-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M15.75 18.375V5.25H17.5C17.9813 5.25 18.3934 5.4215 18.7364 5.7645C19.0794 6.1075 19.2506 6.51933 19.25 7V16.625C19.25 17.1062 19.0788 17.5184 18.7364 17.8614C18.394 18.2044 17.9818 18.3756 17.5 18.375H15.75ZM8.75 5.25H12.25V3.5H8.75V5.25ZM7 18.375V3.5C7 3.01875 7.1715 2.60692 7.5145 2.2645C7.8575 1.92208 8.26933 1.75058 8.75 1.75H12.25C12.7312 1.75 13.1434 1.9215 13.4864 2.2645C13.8294 2.6075 14.0006 3.01933 14 3.5V18.375H7ZM3.5 18.375C3.01875 18.375 2.60692 18.2038 2.2645 17.8614C1.92208 17.519 1.75058 17.1068 1.75 16.625V7C1.75 6.51875 1.9215 6.10692 2.2645 5.7645C2.6075 5.42208 3.01933 5.25058 3.5 5.25H5.25V18.375H3.5Z"
                    fill="black"
                  />
                </svg>
                <div>{t("RequestYourPlan")}</div>
              </div>
              <div className="details-card-package-desc">
                {t("RequestPlanDescription")}
              </div>
              <div className="details-card-package-label">
                {t("NumberOfTravelers")}
              </div>
              <TravelerSelector
                adults={adults}
                children={children}
                childrenAges={childrenAges}
                infants={infants}
                onAdultsChange={setAdults}
                onChildrenChange={setChildren}
                onChildrenAgesChange={setChildrenAges}
                onInfantsChange={setInfants}
              />
              {errors.childrenAges && (
                <div className="invalid-feedback">{errors.childrenAges}</div>
              )}

              <div className="details-card-package-label">
                {t("NumberOfRooms")}
              </div>
              <RoomSelector
                totalTravelers={totalTravelers}
                single={single}
                double={double}
                triple={triple}
                setSingle={setSingle}
                setDouble={setDouble}
                setTriple={setTriple}
                onRoomsChange={handleRoomsChange}
              />

              {errors.rooms && (
                <div className="error-message">{t(errors.rooms)}</div>
              )}

              {/* <div className="details-card-package-label">
                {t("TravelDate")}
              </div>
              <RangeCalendar
                value={selectedRange}
                onChange={handleDateChange}
                // minDate={packageData?.availability_start_date}
                minDate={
                  new Date(
                    Math.max(
                      new Date().setHours(0, 0, 0, 0),
                      new Date(packageData?.availability_start_date).setHours(
                        0,
                        0,
                        0,
                        0
                      )
                    )
                  )
                }
                maxDate={packageData?.availability_end_date}
              />
              {errors.selectedRange && (
                <div className="invalid-feedback">{errors.selectedRange}</div>
              )} */}

              <div className="details-card-package-label">
                {t("TravelDate")}
              </div>

              <SingleCalendar
                value={startDate}
                onChange={handleDateChange}
                min={
                  new Date(
                    Math.max(
                      new Date().setHours(0, 0, 0, 0),
                      new Date(packageData?.availability_start_date).setHours(
                        0,
                        0,
                        0,
                        0
                      )
                    )
                  )
                }
                max={new Date(packageData?.availability_end_date)}
              />

              {errors.startDate && (
                <div className="invalid-feedback">{errors.startDate}</div>
              )}

              <div className="details-card-package-label">{t("EndDate")}</div>
              <input
                type="text"
                className="details-card-input"
                value={endDate ? dayjs(endDate).format("DD/MM/YYYY HH:mm") : ""}
                readOnly
              />

              <div className="flexible-travel-dates-row">
                <label className="checkbox-container">
                  <input
                    type="checkbox"
                    checked={flexibleTravelDates}
                    onChange={(e) => setFlexibleTravelDates(e.target.checked)}
                  />
                </label>
                <div className="details-card-package-label">
                  {t("FlexibleTravelDates")}
                </div>
              </div>

              <div className="details-card-package-label">
                {t("PriceStartFrom")}
              </div>
              <div className="details-card-package-price">
                <div>
                  {price !== null
                    ? `${price.toLocaleString()}`
                    : calculatePrice().toLocaleString()}
                </div>
                <span>{packageData?.currency_symbol || "SAR"}</span>
              </div>
              <div className="details-card-package-para">
                {t("WhatsappChatDescription")}
                {/* Chat with us on <span>WhatsApp</span> or or enter your details
                and we will contact you to help customize your package! — we’ll
                handle the rest! */}
              </div>
              <a
                href={`https://wa.me/966554482522?text=${encodeURIComponent(
                  whatsAppMessage
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="details-card-whatsapp-btn-link"
              >
                <div
                  className="details-card-whatsapp-btn"
                  onClick={() => setShowModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1210_2323)">
                      <mask
                        id="mask0_1210_2323"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="18"
                        height="18"
                      >
                        <path d="M0 0H18V18H0V0Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0_1210_2323)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.0613 10.7865C12.8378 10.6748 11.742 10.1363 11.538 10.0613C11.334 9.98628 11.1855 9.95028 11.0363 10.1738C10.8877 10.3965 10.461 10.8983 10.3312 11.0468C10.2007 11.196 10.071 11.214 9.84825 11.103C9.6255 10.9905 8.907 10.7558 8.05575 9.99678C7.3935 9.40578 6.94575 8.67603 6.816 8.45253C6.68625 8.22978 6.80175 8.10903 6.9135 7.99803C7.014 7.89828 7.13625 7.73778 7.248 7.60803C7.35975 7.47828 7.3965 7.38453 7.47075 7.23528C7.54575 7.08678 7.50825 6.95703 7.452 6.84528C7.3965 6.73353 6.951 5.63628 6.765 5.19003C6.58425 4.75578 6.4005 4.81503 6.264 4.80753C6.1335 4.80153 5.985 4.80003 5.8365 4.80003C5.688 4.80003 5.4465 4.85553 5.2425 5.07903C5.03775 5.30178 4.4625 5.84103 4.4625 6.93828C4.4625 8.03478 5.2605 9.09453 5.37225 9.24378C5.484 9.39303 6.9435 11.6438 9.17925 12.609C9.71175 12.8385 10.1265 12.9758 10.4497 13.0778C10.9837 13.248 11.4698 13.224 11.8538 13.1663C12.2812 13.1025 13.1723 12.627 13.3583 12.1065C13.5443 11.586 13.5435 11.1398 13.488 11.0468C13.4325 10.9538 13.284 10.8983 13.0605 10.7865M8.994 16.3388H8.991C7.66307 16.339 6.35953 15.982 5.217 15.3053L4.947 15.1448L2.1405 15.8813L2.88975 13.1453L2.7135 12.8648C1.97107 11.6831 1.57818 10.3154 1.58025 8.91978C1.58175 4.83228 4.90725 1.50678 8.997 1.50678C9.97108 1.50382 10.936 1.69451 11.8358 2.06777C12.7355 2.44102 13.5521 2.9894 14.238 3.68103C14.9284 4.36825 15.4755 5.18559 15.8479 6.08573C16.2202 6.98587 16.4102 7.95093 16.407 8.92503C16.4055 13.0125 13.08 16.3388 8.994 16.3388ZM15.303 2.61603C14.4766 1.78448 13.4935 1.1251 12.4105 0.67606C11.3276 0.227022 10.1663 -0.00275648 8.994 2.49524e-05C4.0785 2.49524e-05 0.0765 4.00128 0.075 8.91903C0.0725805 10.4841 0.483149 12.0221 1.26525 13.3778L0 18L4.728 16.7595C6.03613 17.4715 7.50165 17.8449 8.991 17.8455H8.99475C13.9102 17.8455 17.9123 13.8443 17.9137 8.92578C17.9174 7.75373 17.6886 6.59258 17.2406 5.50953C16.7926 4.42647 16.1343 3.443 15.3038 2.61603"
                          fill="white"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_1210_2323">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <div>{t("ContactWhatsapp")}</div>
                </div>
              </a>
              <div class="divider">
                <span>{t("Or")}</span>
              </div>
              <div className="details-card-package-label">{t("FullName")}</div>
              <input
                className="details-card-input"
                type="text"
                placeholder={t("ValidationFullName")}
                value={full_name || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setFullName(value);
                }}
              />
              {errors.full_name && (
                <div className="invalid-feedback">{errors.full_name}</div>
              )}
              <div className="details-card-package-label">{t("Email")}</div>
              <input
                className="details-card-input"
                type="email"
                placeholder={t("ValidationEmail")}
                value={email || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setEmail(value);
                }}
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
              <div className="details-card-package-label">
                {t("MobileNumber")}
              </div>
              <input
                className="details-card-input"
                type="tel"
                placeholder={t("ValidationMobileNumber")}
                value={mobile_number}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
              {errors.mobile_number && (
                <div className="invalid-feedback">{errors.mobile_number}</div>
              )}
              <button
                className={`details-card-whatsapp-btn colored ${
                  request_loading ? "disabled" : ""
                }`}
                onClick={handleRequest}
                disabled={request_loading}
              >
                <div>{t("RequestCallBack")}</div>
              </button>

              {/* <ComingSoon show={showModal} onClose={() => setShowModal(false)} /> */}
              <ToastContainer
                position="bottom-right"
                hideProgressBar="true"
                type="error"
              />
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="success"
            className="request-success-message"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.5 }}
          >
            <h3>{t("ThankYou")}</h3>
            <p>{t("SuccessSubmit")}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Card;
